import { IDS } from '../improvement-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../improvement.actions';
import watch from "redux-watch";
import moment from 'moment'

class ImprovementListGridController extends GridController {
    constructor($ngRedux, $state, $stateParams, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.rcoImprovement;
        this.statePath = IDS.improvementActionsGrid;

        this.filterTemplate = '../../improvement-actions/list/list-grid-filter.html';
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.title = false;
        this.icon = false;
        this.confirmDialogOnRemove = true;
        // this.autoload = false;

        this.isAdmin = this.AuthService.getUser().typeCode === 'adm';
        this.filterActions.isAdmin = this.isAdmin;
        this.columns = [
            {title: '#', mapper: null},
            {title: this.$filter('translate')('COMMON.FIELD.TASK_NUMBER'),      mapper: 'task_number'},
            {title: 'Title',                                                    mapper: 'name'},
            {title: this.$filter('translate')('ACCREDITATION.COMMON.REQUIREMENT'),  mapper: 'requirementsColumn'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper: 'assignee'},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),           mapper: (item) => item.status_code === 'pen' ? item.completed_vs_total_subtasks : item.status_name}
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.isManager = this.AuthService.isManager();
        this.filterActions.isManager = this.isManager;
        if(!this.isManager && !this.isAdmin) {
            const filteredColumns = this.columns.concat().filter(column => !['assignee'].includes(column.mapper));
            filteredColumns.splice(4,0,{title: this.$filter('translate')('ACCREDITATION.COMMON.DOCUMENT'), mapper: 'description'});
            this.columns = filteredColumns;
        }

        const $rootScope = this.$rootScope;
        const watchReset = watch(this.$ngRedux.getState, 'accreditation.accTasksGrid.reset');
        this.unsubscribeOnReset = this.$ngRedux.subscribe(watchReset(function() {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'accreditationTasksFilterForm');
        }));
        this.dataAction = (filter) => {
            filter.scheme_code = this.$stateParams.itemCode;
            filter.year_start = this.$stateParams.year || parseInt(moment().format('YYYY'));
            this.fetchImprovementActionsGrid(filter)
        };
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }

}

ImprovementListGridController.$inject = ['$ngRedux', '$state', '$stateParams', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope', 'AuthService'];

export const improvementActionsGrid = {
    bindings: {
        onSelect: '&',
    },
    controller: ImprovementListGridController,
    ...gridTpl
}
